import { Country } from "./country.dto";
import {PaginatorInfo} from "./generic.dto";

export type TaxReliefType = {
  id: number
  countryId: number
  code: string
  name: string
  description: string
  createdAt: string
  modifiedAt: string | null
}

export class CreateTaxReliefTypeDto {
  countryId!: number
  code!: string
  name!: string
  description!: string
}

export interface TaxReliefTypeDto extends TaxReliefType {
  country?: Country
}

export interface TaxReliefTypePaginator extends PaginatorInfo<TaxReliefTypeDto> {}

export class UpdateTaxReliefTypeDto {
  code?: string
  name?: string
  description?: string
}

export class QueryTaxReliefTypeDto {
  countryId?: number;
  code?: string
  page?: number = 1;
  limit?: number;
  orderBy?: TaxReliefTypeOrderBy = TaxReliefTypeOrderBy.CREATED_AT_ASC;
}

export class SearchTaxReliefTypeDto {
  q?: string;
  page?: number = 1;
  limit?: number;
  orderBy?: TaxReliefTypeOrderBy = TaxReliefTypeOrderBy.CREATED_AT_ASC;
}

export enum TaxReliefTypeOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc',
  CODE_ASC = 'code:asc',
  CODE_DESC = 'code:desc',
  NAME_ASC = 'name:asc',
  NAME_DESC = 'name:desc',
}